const benefitsData = {
  trainer: {
    slogan: "Załóż konto, zapełnij swój grafik i zarabiaj ponad 100zł/h!",
    benefitsArray: [
      "Możliwość wystawiania ogłoszeń w różnych kategoriach",
      "Dostęp do bieżących  ogłoszeń osób szukających aktualnie pomocy w dziedzinie w której jesteś ekspertem!",
      "Reklamę siebie i swoich usług przed tysiącami osób w całej Polsce",
    ],
  },
  client: {
    slogan:
      "Załóż konto, dodaj ogłoszenie, a specjalista skontaktuje się z Tobą!",
    benefitsArray: [
      "Stały kontakt z twoim ekspertem",
      "Możliwość wystawiania opinii",
      "Możliwość tworzenia ogłoszeń jako potrzebujący",
    ],
  },
};

export default benefitsData;
